module.exports = __webpack_public_path__ + "assets/exclamação-azul.b178023d.svg";